module.exports = __webpack_public_path__ + "img/oficina-españa.548c1414.png";